// src/screens/PreCount/PreCountScreen.js
import React, { useContext, useEffect, useState } from 'react';
import CountContext from '../../context/CountContext.js';
import { useAuth } from '../../AuthContext.js';

export default function PreCountScreen({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const { preCount } = state;
  const { user: authUser } = useAuth();

  // Local form state, seeded from context or auth user
  const [inputs, setInputs] = useState({
    store: preCount.store || authUser.store || '',
    date: preCount.date || new Date().toISOString().split('T')[0],
    shift: preCount.shift || 'morning',
    startingBalance: preCount.startingBalance != null ? preCount.startingBalance.toString() : '',
    manager: preCount.manager || authUser.username || ''
  });
  
  // Sync authUser fields into inputs if context is empty
  useEffect(() => {
    if (!preCount.store && authUser.store) {
      setInputs(prev => ({ ...prev, store: authUser.store }));
    }
    if (!preCount.manager && authUser.username) {
      setInputs(prev => ({ ...prev, manager: authUser.username }));
    }
  }, [authUser.store, authUser.username]);

  const handleChange = (field) => (e) => {
    const { value } = e.target;
    setInputs(prev => ({ ...prev, [field]: value }));
  };

  const handleConfirm = () => {
    // Dispatch each field to context
    dispatch({ type: 'UPDATE_PRECOUNT_FIELD', payload: { field: 'store', value: inputs.store } });
    dispatch({ type: 'UPDATE_PRECOUNT_FIELD', payload: { field: 'date', value: inputs.date } });
    dispatch({ type: 'UPDATE_PRECOUNT_FIELD', payload: { field: 'shift', value: inputs.shift } });
    dispatch({ type: 'UPDATE_PRECOUNT_FIELD', payload: { field: 'startingBalance', value: parseFloat(inputs.startingBalance) || 0 } });
    dispatch({ type: 'UPDATE_PRECOUNT_FIELD', payload: { field: 'manager', value: inputs.manager } });
    onNext();
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-4">
      <h2 className="text-2xl font-bold">Pre-Count Details</h2>
      <div className="space-y-3">
        {/* Store / Location */}
        <div>
          <label className="block mb-1">Store / Location</label>
          <input
            type="text"
            value={inputs.store}
            onChange={handleChange('store')}
            className="border rounded p-1 w-full"
          />
        </div>
        {/* Date */}
        <div>
          <label className="block mb-1">Date</label>
          <input
            type="date"
            value={inputs.date}
            onChange={handleChange('date')}
            className="border rounded p-1 w-full"
          />
        </div>
        {/* Shift */}
        <div>
          <label className="block mb-1">Shift</label>
          <select
            value={inputs.shift}
            onChange={handleChange('shift')}
            className="border rounded p-1 w-full"
          >
            <option value="morning">Morning</option>
            <option value="evening">Evening</option>
          </select>
        </div>
        {/* Starting Balance */}
        <div>
          <label className="block mb-1">Starting Balance</label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={inputs.startingBalance}
            onChange={handleChange('startingBalance')}
            className="border rounded p-1 w-full"
          />
        </div>
        {/* Manager */}
        <div>
          <label className="block mb-1">Manager</label>
          <input
            type="text"
            value={inputs.manager}
            onChange={handleChange('manager')}
            className="border rounded p-1 w-full"
          />
        </div>
      </div>
      {/* Navigation Buttons */}
      <div className="flex justify-between mt-6">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Back
        </button>
        <button
          onClick={handleConfirm}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          Confirm Pre-Count
        </button>
      </div>
    </div>
  );
}
